import { render, staticRenderFns } from "./SwapUnexpectedErrorStep.vue?vue&type=template&id=4b20dda9"
import script from "./SwapUnexpectedErrorStep.vue?vue&type=script&lang=ts"
export * from "./SwapUnexpectedErrorStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapUnexpectedErrorStep.vue?vue&type=style&index=0&id=4b20dda9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports